import { SmartActionButton } from '@bingads-webui-campaign-react/smart-component-action-button';
import { SmartCoverImage } from '@bingads-webui-campaign-react/smart-component-cover-image';
import { SmartHeader } from '@bingads-webui-campaign-react/smart-component-header';
import { SmartFooter } from '@bingads-webui-campaign-react/smart-component-footer';
import { SmartIntroduction } from '@bingads-webui-campaign-react/smart-component-introduction';
import { SmartGallery } from '@bingads-webui-campaign-react/smart-component-gallery';
import { SmartContact } from '@bingads-webui-campaign-react/smart-component-contact';
import { SmartBusinessHours } from '@bingads-webui-campaign-react/smart-component-business-hours';
import { SmartUpdate } from '@bingads-webui-campaign-react/smart-component-update';
import { SmartSummary } from '@bingads-webui-campaign-react/smart-component-summary';
import { SmartSocialLinks } from '@bingads-webui-campaign-react/smart-component-social-links';
import { SmartReview } from '@bingads-webui-campaign-react/smart-component-review';
import { SmartVideo } from '@bingads-webui-campaign-react/smart-component-video';
import { SmartProfessionalService } from '@bingads-webui-campaign-react/smart-component-professional-service';
import { componentsConfig } from '@bingads-webui-campaign-react/smart-component-util';

export const runtimeComponentsMapping = {
  [componentsConfig.header.type]: SmartHeader,
  [componentsConfig.footer.type]: SmartFooter,
  [componentsConfig.introduction.type]: SmartIntroduction,
  [componentsConfig.coverImage.type]: SmartCoverImage,
  [componentsConfig.callToAction.type]: SmartActionButton,
  [componentsConfig.gallery.type]: SmartGallery,
  [componentsConfig.contact.type]: SmartContact,
  [componentsConfig.businessHours.type]: SmartBusinessHours,
  [componentsConfig.update.type]: SmartUpdate,
  [componentsConfig.summary.type]: SmartSummary,
  [componentsConfig.professionalService.type]: SmartProfessionalService,
  [componentsConfig.video.type]: SmartVideo,
  [componentsConfig.socialLinks.type]: SmartSocialLinks,
  [componentsConfig.review.type]: SmartReview,
};
